module.exports = __webpack_public_path__ + "img/download_appstore.beec5d83.png";